/**
 * @file   : Trackers.js
 * @author :  ()
 * @date   : 7/31/2019, 3:37:28 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import Tracker from '../../../external/components/misc/Tracker'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'

export const ALL_CONTRACTS = 'ALL'

// eslint-disable-next-line one-var
const Trackers = ({
  trackersConfig = {},
  pageId = null,
  contractCodes = [],
}) => {
  const getPageConfig = function () {
    let pageConfig = null
    for (const page of trackersConfig.pages) {
      if (page.pageId === pageId) {
        pageConfig = page
        break
      }
    }

    return pageConfig
  }

  const isContractInList = function (contractCode) {
    for (const currContractCode of contractCodes) {
      if (currContractCode === contractCode) {
        return true
      }
    }

    return false
  }

  const getTrackers = function () {
    const pageConfig = getPageConfig()

    if (isEmpty(pageConfig)) {
      return null
    }

    let trackersUI = null

    trackersUI = pageConfig.contracts.map((contract, i) => {
      let contractTrackersUI = null
      if (isContractInList(contract.contractCode)) {
        contractTrackersUI = contract.trackers.map((tracker, j) => {
          if (tracker.active) {
            return (
              <Cont key={`${i}-${j}`} asSpan>
                <Tracker source={tracker.source} cmpLabel={tracker.label} />
                {/* <img src={tracker.source} style="display: none;" border="0" height="1" width="1" alt={tracker.label}/> */}
              </Cont>
            )
          }

          return null
        })
      } else {
        return null
      }

      return contractTrackersUI
    })

    return trackersUI
  }

  const shouldEmbed = function () {
    let embed = false
    if (
      !isUndefined(trackersConfig) &&
      !isEmpty(trackersConfig) &&
      !isEmpty(pageId) &&
      !isEmpty(contractCodes)
    ) {
      if (trackersConfig.active) {
        embed = true
      }
    }

    return embed
  }

  if (!shouldEmbed()) {
    return null
  }

  return <Cont>{getTrackers()}</Cont>
}

Trackers.propTypes = {
  trackersConfig: PropTypes.object,
  pageId: PropTypes.string.isRequired,
  contractCodes: PropTypes.array.isRequired,
}

export default Trackers
